var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloadArrow = function SvgDownloadArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10 1.625c.483 0 .875.392.875.875v7.888l2.673-2.673a.875.875 0 0 1 1.237 1.237L10.62 13.12a.875.875 0 0 1-1.238 0L5.215 8.952a.875.875 0 1 1 1.237-1.237l2.673 2.673V2.5c0-.483.392-.875.875-.875m-7.5 10c.483 0 .875.392.875.875v3.333a.79.79 0 0 0 .792.792h11.666a.79.79 0 0 0 .792-.792V12.5a.875.875 0 0 1 1.75 0v3.333a2.54 2.54 0 0 1-2.542 2.542H4.167a2.54 2.54 0 0 1-2.542-2.542V12.5c0-.483.392-.875.875-.875",
    clipRule: "evenodd"
  })));
};
export default SvgDownloadArrow;